import { OrderCommentActionModal } from '../OrderCommentActionModal/OrderCommentActionModal';

export interface StartExecutorSearchModalProps {
    visible: boolean;
    onHide: () => void;
    orderId: string;
}

/** Показывает запуск поиска исполнителя по заказу администратором. */
export const StartExecutorSearchModal = (props: StartExecutorSearchModalProps) => (
    <OrderCommentActionModal
        {...props}
        action="startExecutorSearch"
    />
);
